import { render, staticRenderFns } from "./editor-index.vue?vue&type=template&id=7c0a4346&"
import script from "./editor-index.vue?vue&type=script&lang=js&"
export * from "./editor-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports